export const NR_EVENTS = {
  CANDIDATE_INPUT: "candidate_input",
  CONTEXT_INITIALIZED: "context_initialized",
  API_ERROR: "api_error",
  UI_ERROR: "ui_error",
  IP_FETCHED: "ip_fetched"
} as const;